<script lang="ts">
    import type {Rec} from 'typings/portaro.be.types';
    import Label from 'shared/components/kp-label/Label.svelte';

    export let value: Rec;
</script>

<span class="record-as-chip-tag-model">
    <Label labeled="{value}"/>
</span>

<style lang="less">
    @import (reference) "bootstrap-less/bootstrap/variables";

    .record-as-chip-tag-model {
        display: inline-block;
    }

    :global {
        .record-as-chip-tag-model a {
            font-weight: 500;
            color: @text-color;
        }
    }
</style>